var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-1 pointer",on:{"click":function($event){return _vm.changeOrder()}}},[(_vm.useState)?_c('span',[_c('ArrowOrder',{attrs:{"field":this.field}})],1):_c('span',[(_vm.order == 'asc')?_c('font-awesome-icon',{attrs:{"icon":"chevron-up"}}):_c('font-awesome-icon',{attrs:{"icon":"chevron-down"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }